import _styled from "styled-components";
const _excluded = ["isActive", "children", "style"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import theme, { stylePropType } from '@adsk/alloy-react-theme';
const BreadcrumbWrapper = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
      isActive,
      children,
      style
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(_StyledLi, _extends({
    ref: ref
  }, props, {
    $_css: [{
      display: 'flex',
      alignItems: 'center',
      listStyleType: 'none',
      padding: 0,
      '[role="separator"]': _objectSpread(_objectSpread({
        color: theme.tokens.colors.icon.tertiary.value
      }, theme.typography.bodyMedium), {}, {
        margin: "0 ".concat(theme.spacing.XS, "px")
      })
    }, style]
  }), children, !isActive && /*#__PURE__*/React.createElement("div", {
    role: "separator"
  }, "/"));
});
BreadcrumbWrapper.displayName = 'BreadcrumbWrapper';
BreadcrumbWrapper.propTypes = {
  /** Determines if this breadcrumb is the currently active one */
  isActive: PropTypes.bool,
  /** Children to overwrite the base label and icon */
  children: PropTypes.any,
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string
};
export default BreadcrumbWrapper;
var _StyledLi = _styled("li").withConfig({
  displayName: "BreadcrumbWrapper___StyledLi",
  componentId: "sc-24jy7r-0"
})(["", ""], p => p.$_css);
//# sourceMappingURL=BreadcrumbWrapper.js.map